export const varToString = (varObj: any) => Object.keys(varObj)[0]
